import {
    states,
    server_config,
    behavior_config,
    ico_he,
    reels_pos,
    rotated,
    round_running,
    set_rotated,
    picture_convert,
    server_result,
    alldone,
    in_free_spins,
    fps,
    forcestopnow,
    wallet,
    reels_lenghts,
    set_forcestopnow,
    set_inanim,
    super_win,
    mega_win,
    wi,
    he,
    set_inwincount,
    set_inmoneyadd,
    big_win,
    set_inbigwin, commander
} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_get_currtime,
    madnes_win_anim_reset,
    madnes_win_anim_skip,
    win,
    madnes_money_to_coin,
    madnes_end_round,
    bet,
    madnes_get_atomic_bet,
    madnes_microtime,
    madnes_reels_start,
    madnes_reels_stop,
    madnes_add_win, madnes_is_in_autostart,
	madnes_get_game_specifics
} from "../framework/src/engine/madnes/madnes";
import {cylinder_pos, icons, last_symbol, symbols} from "./ninestars_config";
import {
    madnes_audio_continue,
    madnes_audio_fade_out,
    madnes_audio_is_playing,
    madnes_audio_pause,
    madnes_audio_play,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_add_to_render,
    madnes_alpha_to,
    madnes_move_to,
    madnes_rem_from_render, madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_anim_add,
    madnes_anim_add_oncomplete_once, madnes_anim_is_playing, madnes_anim_loop,
    madnes_anim_play, madnes_anim_stop, madnes_start_coin, madnes_stop_coin,
} from "../framework/src/engine/madnes/madnes_anims";
import {
    madnes_get_pos_x,
    madnes_get_pos_y, madnes_get_scale_y,
    madnes_get_texture,
    madnes_set_alpha, madnes_set_img_center,
    madnes_set_pos,
    madnes_set_pos_y,
    madnes_set_scale,
    madnes_set_texture,
    madnes_sprite_get_frame_name,
    madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {ninestars_print_reels, result_lock, set_result_lock} from "./ninestars_core_printer";
import {ninestars_infomenu_update, ninestars_stars_list, set_ninestars_stars_list} from "./ninestars_reels";
import {ninestars_bonus_start, ninestars_show_money} from "./ninestars_anims";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {STATES} from "../framework/src/states/states";
import {CONFIG_PARAMS, MODES} from "../framework/src/system/SystemConfig";

var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var autospin_force_enabled = false;
var autospin_force = false;

export function ninestars_rotate_run()
{
    if(round_running) //waiting for end round
    {
        return;
    }

    ninestars_rotate_start();
}

function ninestars_rotate_start()
{
    if(rotated == 0)
    {
        //madnes_on_round_start();

        // behavior_config.reel.spin.delayBetweenReelStops1 = Math.ceil(Math.random() * ( behavior_config.reel.spin.delayBetweenReelStops - 1 ) ) + 1;
        // behavior_config.reel.spin.delayBetweenReelStops2 = Math.ceil(Math.random() * ( behavior_config.reel.spin.delayBetweenReelStops - 1 ) ) + 1;


        // madnes_show_stop();

        madnes_win_anim_reset();

        for(var i in server_config.logic.reels)
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        // if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
        // {
        // 	autostart = autostart * 1 - 1;
        // }
        set_rotated(true); // rotated = 1;

        startposin = JSON.parse(JSON.stringify(stopposin));

        // if(!in_free_spins)
        // {
        // 	madnes_new_round();
        // 	force_res = "";
        // }

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }

        //money = money * 1 - bet * 1;

        can_stop = 0;

        rotate_start_time = madnes_get_currtime();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(false); //forcestopnow = 0;
        scatters_runned = false;



        madnes_audio_play("Reel_start");

        madnes_add_to_render(ninestars_rotate_start);
        madnes_reels_start();
    }
    else
    {
        var time = madnes_get_currtime() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc

            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }

        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            //madnes_audio_loop("Reel_spin");
            madnes_audio_play("Reel_spin");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = madnes_get_currtime();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                for(var i = 0; i < cylinder_pos.length; i++)
                {
                    if(behavior_config.reel.spin.motionBlur == 1)
                    {
                        madnes_anim_play("reels_bufer_" + i + "_S0", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S1", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S2", "blur");

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "blur");
                        }

                    }
                }

                rotate_start_in_accel = 1;

                // ninestars_rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
                rotate_control_start_time = madnes_get_currtime();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;

            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                end_speed = behavior_config.reel.spin.freeSpinSpeed;
            }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i * 1 + sampling * 1)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
                }

                rotate_control_swing_end = pos;

                madnes_rem_from_render(ninestars_rotate_start);
                madnes_add_to_render(ninestars_rotate_control);
            }
        }

        ninestars_print_reels();
    }
}

// Kontrola probihajici rotace valcu

export const stopposin = new Array();
export let startposin = new Array();

export const stopposin_round = new Array();
var stopping = new Array();

export const stopposin_old = new Array();
export const stoppostime_br = new Array();
export const stoppostime = new Array();

var stoppos_swing = new Array();

var scatters = 0;
var saloons = 0;
var all_set_for_stop = 0;

var scatters_runned = false;
function ninestars_rotate_control()
{
    var time = madnes_get_currtime();

    if(rotated == 1 || all_set_for_stop == 0)
    {
        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null && result_lock == 0)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stopping[i] = 0;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }

        scatters = 0;
        saloons = 0;

    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(forcestopnow === 1)
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    var del2 = 1;

                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del2 = behavior_config.reel.spin.delayBetweenReelStops;
                    }

                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }

                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i == 1)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( del );
                    }

                    if(i == 2)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( del * 1 + del2 * 1 );
                    }
                }
                /*
                var sc_tmp = 0;
                var sa_tmp = 0;

                var add_tmp_sc = 0;
                var add_tmp_sa = 0;

                for(var j = 0; j < i; j++)
                {
                    for(var spos = 0; spos <= 2; spos++)
                    {
                        if(server_result.result.reelMatrix[0][j][spos] == 8)
                        {
                            sa_tmp++;
                        }
                        else if(server_result.result.reelMatrix[0][j][spos] == 9)
                        {
                            sc_tmp++
                        }
                    }
                    if(sa_tmp >= 2)
                    {
                        add_tmp_sa++;
                    }
                    if(sc_tmp >= 2)
                    {
                        add_tmp_sc++;
                    }
                }

                if(sa_tmp >= 2 || sc_tmp >= 2)
                {
                    if(typeof behavior_config.reel.spin.scatterDuration != "undefined")
                    {
                        var add = add_tmp_sc;
                        if(add_tmp_sa > add)
                        {
                            add = add_tmp_sa;
                        }
                        add = add - 1;
                        var tmp_dur = behavior_config.reel.spin.scatterDuration * 1 + behavior_config.reel.spin.scatterDelay * add;
                        stopposin[i] += tmp_dur * 1;
                    }
                    else
                    {
                        stopposin[i] += 20;
                    }
                }
                */

                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(forcestopnow == 1)
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                forcestopnow == 0 &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );

            }
            else if(stoppostime[i] == -1)
            {
                stopping[i] = 1;

                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;

                    if(!in_free_spins)
                    {
                        //wanted_freespin_hide(i + 1);
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone[i] == 0)
                    {
                        control_show_spin(i);
                        ninestars_control_stop_sound(i);

                        for(var spos = 0; spos <= 2; spos++)
                        {
                            /*
                            if(server_result.result.reelMatrix[0][i][spos] == 8)
                            {
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "nowin")
                                saloons++;
                            }
                            else if(server_result.result.reelMatrix[0][i][spos] == 9)
                            {
                                // SCATTER
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                                ninestars_scatter_scale_anim(i, 'S'+(2-spos), 0);
                                scatters++;
                            }
                            else
                            {
                                */
                            madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                            /*
                        }*/

                            if(
                                (
                                    scatters == 2 ||
                                    saloons == 2
                                )
                                &&
                                scatters_runned == false &&
                                forcestopnow == 0 &&
                                i < 4
                            )
                            {
                                scatters_runned = true;
                                for(var ii = i+2; ii <= 5; ii++)
                                {
                                    if(forcestopnow === 0)
                                    {
                                        wanted_freespin_show(ii);
                                    }
                                }
                                madnes_audio_play("REEL_TEAS");
                            }
                        }

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
                        }
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;
                //var mt = behavior_config.reel.brake.moveTime;
                var mt = behavior_config.reel.brake.moveBackTime;


                var cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                if(dif_time < mt * 1000)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000)
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
                {
                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );

                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        )
                        %
                        (
                            ( ( reels_lenghts[i] * 1 ) + 0 ) * ico_he
                        );

                }
                else
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        alldone[i] = 1;
                    }
                }

            }
        }

        if(alldone.indexOf(0) == -1)
        {
            madnes_audio_stop("Reel_spin");
            setTimeout(ninestars_result_control, 100);
            madnes_rem_from_render(ninestars_rotate_control);

            madnes_reels_stop();
            //madnes_hide_stop();
        }

    }

    ninestars_print_reels();
}

function control_show_spin(reel) {
    if(reel == 1 && !in_free_spins && !madnes_is_in_autostart())
    {
        states.setState(STATES.FORCESPIN);
        // autospin_force_enabled = true;
        // madnes_show_spin();
    }

}

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    //var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    if(!isFinite(end_speed) || isNaN(end_speed))
    {
        end_speed = 0;
    }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

// Pozadavek na dotoceni valce
var ninestars_rotate_stop_loading = 0;
export function ninestars_rotate_stop()
{
    if(rotated != 0 && ninestars_rotate_stop_loading == 0)
    {
        for(var i = 0; i < cylinder_pos.length; i++)
        {
            stopposin_old[i] = -1;
        }
        all_set_for_stop = 0;
        ninestars_rotate_stop_loading = 1;
        var poss = 0;
        for(var i in server_result.result.reelMatrix[0])
        {
            for(var j in server_result.result.reelMatrix[0][i])
            {
                (function(i, j) {

                    var name = "reels_bufer_" + i + "_S" + ( 2 - j );
                    var symbolName = picture_convert[server_result.result.reelMatrix[0][i][j]];

                    setTimeout(function() {

                        madnes_set_texture(name, symbolName + "_blur");
                        madnes_anim_add(name, "blur", [0]);
                        madnes_anim_add(name, "stop", [1]);

                        if(behavior_config.reel.spin.motionBlur == 1)
                        {
                            madnes_anim_play(name, "blur");
                        }
                        else
                        {
                            madnes_anim_play(name, "stop");
                        }

                    }, (1000 / ( fps ) ) * poss);

                } (i, j));
            }
        }

        setTimeout(function () {
            all_set_for_stop = 1;
            ninestars_rotate_stop_loading = 0;
        }, (1000 / ( fps ) ) * poss);

        set_rotated(false); // rotated = 0;
    }
}

export let ninestars_control_sound_noset = [];
export function set_ninestars_control_sound_noset(set) {
    ninestars_control_sound_noset = set;
}

function ninestars_control_stop_sound(reel)
{
    madnes_audio_play("Reel_stop_"+ ( reel * 1 + 1 ) );

    var up_sym = server_result.result.reelMatrix[0][reel][0];
    var mi_sym = server_result.result.reelMatrix[0][reel][1];
    var dn_sym = server_result.result.reelMatrix[0][reel][2];

    if(up_sym == 8 || mi_sym == 8 || dn_sym == 8)
    {
        madnes_audio_play("Star_stop");

        var names = [];
        if(up_sym == 8)
        {
            names[names.length] = "reels_bufer_" + reel + "_S2";
        }

        if(mi_sym == 8)
        {
            names[names.length] = "reels_bufer_" + reel + "_S1";
        }

        if(dn_sym == 8)
        {
            names[names.length] = "reels_bufer_" + reel + "_S0";
        }

        let realbet = madnes_get_atomic_bet();
        let betIndex = wallet.getBetSet().indexOf(realbet);

        for(var i in names)
        {
            var name = names[i];

            var he = madnes_get_scale_y(name);

            if(
                //ninestars_stars_list[server_config.logic.bet_set.indexOf(bet * 100 * coin_val)][name.split("_")[2] * 3 + ( 2 - name.split("_")[3].replace("S","") * 1 ) * 1 ] == 0
                ninestars_stars_list[betIndex][name.split("_")[2] * 3 + ( 2 - name.split("_")[3].replace("S","") * 1 ) * 1 ] == 0
            )
            {
                setTimeout(
                    function(name, he)
                    {
                        ninestars_control_sound_noset[ninestars_control_sound_noset.length] = name;
                        madnes_scale_to(name, 1.2, he * 1.2, 100, function(name, he)
                        {
                            madnes_scale_to(name, 1, he, 120, function(name)
                                {
                                    var nset = [];
                                    for(var i in ninestars_control_sound_noset)
                                    {
                                        if(ninestars_control_sound_noset[i] != name)
                                        {
                                            nset[nset.length] = ninestars_control_sound_noset[i];
                                        }
                                    }
                                    set_ninestars_control_sound_noset(nset); // ninestars_control_sound_noset = nset;
                                }.bind(this, name)
                            );
                        }.bind(this, name, he));
                    }.bind(this, name, he), 40
                );
            }

        }
    }
}


// Zacatek kontroly vyher
var result_control_pos = 0;
function ninestars_result_control()
{

    set_inanim(true); //inanim = 1;
    result_control_pos = 0;

    toboom = [];
    boom_reel_pos = 0;
    tetris_pos = 0;
    symbol_count = [];

    ninestars_result_control_part();
}

// kontrola vyhry na aktualni pozici
async function ninestars_result_control_part()
{

    if(server_result.result.lineWins == null)
    {
        tetris_fst = false;

        ninestars_print_reels();

        madnes_win_anim_reset();

        // try {
        //     ninestars_stars_list[server_config.logic.bet_set.indexOf(madnes_get_money_bet(bet))] = server_result.result.gameSpecifics.stars;
        // } catch(e) {
        // 	console.log(e)
        // }
        //
        // ninestars_infomenu_update();
        // ninestars_star_control();

        ninestars_money_add_control();

        return;
    }
    if(server_result.result.lineWins[result_control_pos] == null)
    {
        if(
            server_result.result.lineWins[0] != null &&
            server_result.result.lineWins[0].multiplier == 2 &&
            madnes_get_pos_x("bigwin_x2_background_sprite") > 0
        )
        {
            madnes_audio_fade_out("2x_long", 500);

            madnes_anim_stop("bigwin_x2_background_sprite");
            madnes_set_pos("bigwin_x2_background_sprite", -9999, -9999);
            madnes_set_pos("reels_full_plate", -9999, -9999);
        }

        ninestars_print_reels();

        tetris_fst = false;

        madnes_win_anim_reset();
        for(var i = 0; i < 3; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
            }
        }

        // try {
        //     ninestars_stars_list[server_config.logic.bet_set.indexOf(madnes_get_money_bet(bet))] = server_result.result.gameSpecifics.stars;
        // } catch(e) {
        // 	console.log(e);
        // }
        // ninestars_infomenu_update();
        // ninestars_star_control();

        ninestars_money_add_control();

        return;
    }
    else
    {
        states.setState(STATES.SKIP);

        // madnes_hide_stop();

        /*
        if(tetris_fst === true)
        {
            tetris_fst = false;
            ninestars_multi_tetris();
            return;
        }
        */
        if(madnes_win_anim_skip())
        {

            if(
                server_result.result.lineWins[0] != null &&
                server_result.result.lineWins[0].multiplier == 2 &&
                madnes_get_pos_x("bigwin_x2_background_sprite") > 0
            )
            {
                madnes_audio_fade_out("2x_long", 500);

                madnes_anim_stop("bigwin_x2_background_sprite");
                madnes_set_pos("bigwin_x2_background_sprite", -9999, -9999);
                madnes_set_pos("reels_full_plate", -9999, -9999);
            }

            if(
                server_result.result.lineWins[result_control_pos].type == "wild" ||
                server_result.result.lineWins[result_control_pos].type == "normal"
            )
            {
                if(typeof server_result.result.lineWins[result_control_pos].win != "undefined")
                {
                    await madnes_add_win(server_result.result.lineWins[result_control_pos].win * server_result.result.lineWins[result_control_pos].multiplier);
                    // win = win * 1 + server_result.result.lineWins[result_control_pos].win * server_result.result.lineWins[result_control_pos].multiplier;
                }
                result_control_pos++;
                ninestars_result_control_part();
            }
            else
            {
                //console.log(server_result.result.lineWins[result_control_pos]);
                ninestars_result_control_part_proc(server_result.result.lineWins[result_control_pos]);
            }
        }
        else
        {

            if(
                (
                    result_control_pos == 0 &&
                    server_result.result.lineWins[0].type != "star" &&
                    server_result.result.lineWins[0].multiplier == 2 &&
                    //madnes_get_pos_x("bigwin_background_sprite") < 0
                    madnes_get_pos_x("bigwin_x2_background_sprite") < 0
                )
                ||
                (
                    result_control_pos == 0 &&
                    server_result.result.lineWins[0].type == "star" &&
                    server_result.result.lineWins[1] != null &&
                    typeof server_result.result.lineWins[1] != "undefined" &&
                    server_result.result.lineWins[1].multiplier == 2 &&
                    //madnes_get_pos_x("bigwin_background_sprite") < 0
                    madnes_get_pos_x("bigwin_x2_background_sprite") < 0
                )
            )
            {
                madnes_set_alpha("bigwin_x2_background_sprite", 0);

                madnes_set_pos("bigwin_x2_background_sprite", wi / 2, he * 0.47);
                madnes_set_pos("reels_full_plate", 0, 0);
                madnes_set_alpha("reels_full_plate", 0);
                madnes_set_scale("bigwin_x2_background_sprite", 0.8, 0.8);
                madnes_anim_loop("bigwin_x2_background_sprite", "anim", 20);
                madnes_audio_play("2x_long");

                if(server_result.result.lineWins[server_result.result.lineWins.length - 1].type != "bonus")
                {
                    madnes_alpha_to("bigwin_x2_background_sprite", 1, 1000);
                    madnes_alpha_to("reels_full_plate", 1, 1000, ninestars_result_control_part);
                }
                else
                {
                    setTimeout(ninestars_result_control_part, 400);
                }
                return;
            }

            ninestars_result_control_part_proc(server_result.result.lineWins[result_control_pos]);
        }
    }
}

var symbol_count = [];

var audio_name = "";

// kontrola aktualni vyhry
function ninestars_result_control_part_proc(win_set)
{

    set_inwincount(true); // inwincount = true;

    var linenum = 0;
    if(win_set.line != null && typeof win_set.line != "undefined" && win_set.line >= 0 && win_set.line <= 9)
    {
        linenum = win_set.line + 1;
    }

    if(linenum != 0 || 1)
    {
        if(linenum >= 1 && linenum <= 5)
        {
            madnes_alpha_to("winline_number_" + linenum + "_l_a", 1, 250);
            madnes_alpha_to("winline_number_" + linenum + "_r_a", 1, 250);
            switch(linenum)
            {
                case 1:
                    madnes_alpha_to("active_winline_left_mid", 1, 250);
                    madnes_alpha_to("active_winline_right_mid", 1, 250);
                    break;
                case 2:
                    madnes_alpha_to("active_winline_left_mid_top", 1, 250);
                    madnes_alpha_to("active_winline_right_mid_top", 1, 250);
                    break;
                case 3:
                    madnes_alpha_to("active_winline_left_mid_bot", 1, 250);
                    madnes_alpha_to("active_winline_right_mid_bot", 1, 250);
                    break;
                case 4:
                    madnes_alpha_to("active_winline_left_bottom", 1, 250);
                    madnes_alpha_to("active_winline_right_top", 1, 250);
                    break;
                case 5:
                    madnes_alpha_to("active_winline_left_top", 1, 250);
                    madnes_alpha_to("active_winline_right_bottom", 1, 250);
                    break;
            }
        }

        madnes_audio_pause('BACKGROUND');

        //ninestars_show_line(linenum);

        // madnes_win_anim_add();

        // AUDIO
        if(win_set.type == "bonus")
        {
            states.setState(STATES.BONUS);

            ninestars_result_control_part_proc_trn(win_set);
            return;
        }
        else if(win_set.type == "star")
        {

            //console.log("win_set - star");

            //ninestars_stars_list[server_config.logic.bet_set.indexOf(bet * 100 * coin_val)] = server_result.result.gameSpecifics.stars;

            try {
                ninestars_stars_list[wallet.getBetSet().indexOf(madnes_get_atomic_bet(bet))] = madnes_get_game_specifics().stars;
            } catch (e) {
                console.log(e);
            }

            ninestars_infomenu_update();

            madnes_audio_play("Star_fill");
        }
        else
        {
            var symbol = picture_convert[win_set.symbol].toUpperCase();

            symbol = symbol.split("_");
            symbol = symbol[1];

            switch(symbol.toUpperCase())
            {
                case "STAR":		symbol = "win_High_"; break;
                case "DIAMOND":		symbol = "win_High_"; break;
                case "RED7":		symbol = "win_Low_"; break;
                case "WHITE7":		symbol = "win_Low_"; break;
                case "BLUE7":		symbol = "win_Low_"; break;
                case "REDBAR":		symbol = "win_Low_"; break;
                case "BLUEBAR":		symbol = "win_Low_"; break;
                case "WHITEBAR":	symbol = "win_Low_"; break;
                case "CHERRY":		symbol = "win_Low_"; break;

                default: console.log(symbol); symbol = "Cherry_0"; break;
            }

            if(symbol != "")
            {
                if(typeof symbol_count[symbol] == "undefined")
                {
                    symbol_count[symbol] = 1;
                }
                else
                {
                    symbol_count[symbol] = symbol_count[symbol] * 1 + 1;
                    if(symbol_count[symbol] > 5)
                    {
                        symbol_count[symbol] = 1;
                    }
                }
            }

            if(symbol != "")
            {
                audio_name = symbol + "" + symbol_count[symbol];
            }

            if(win_set.multiplier == 2)
            {
                audio_name = "2x_symbol";
            }

            if(audio_name != "")
            {
                setTimeout(madnes_audio_play.bind(this,audio_name), 40);
            }
        }

        ninestars_result_control_part_proc_trn(win_set);
    }
    /*else if(win_set.type == "scatter")
    {
        inwincount = false;
        audio_name = "WIN_LINE_SCATTER_"+win_set.position.length;
        madnes_audio_play(audio_name);

        for(var i = 0; i < 3; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
            }
        }

        for(var i = 0; i < 3; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                var is_win = 0;
                for(var wset in win_set.position)
                {
                    if(win_set.position[wset][0] == i && win_set.position[wset][1] == j)
                    {
                        //console.log(2);
                        madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "anim");
                    }
                }
            }
        }

        if(!in_free_spins && in_free_spins_total == 0)
        {
            madnes_audio_pause('BACKGROUND');
            setTimeout(function() {
                madnes_audio_loop('BACKGROUND_FS');
            }, 1500);

        }

        if(in_free_spins_total * 1 != server_result.result.freeSpinNumber * 1)
        {
            setTimeout("ninestars_add_free_spins()", 800);
             return;
        }

        if(!in_free_spins)
        {
            in_free_spins = true;
            in_free_spins_pos = 0;
            madnes_set_text("free1", in_free_spins_pos.toString());

            setTimeout("ninestars_control_freespins()", 2000);
        }
        else
        {
            setTimeout("ninestars_control_freespins()", 1000);
        }

    }*/
    else
    {
        result_control_pos++;
        ninestars_result_control_part();
        /*
        if(in_free_spins)
        {
            ninestars_control_freespins();
        }
        */
    }
}

// Vstup do freespinu + animace pridani spinu
var in_free_spins_tmp = false;
/*
function ninestars_add_free_spins()
{
	if(!in_free_spins)
	{
		if(freepanelpos > 0)
		{
			freepanelpos = freepanelpos * 1 - 10;
			madnes_set_pos_y("table_free-spins", he + freepanelpos);
			madnes_set_pos_y("free1", he + freepanelpos);
			madnes_set_pos_y("free2", he + freepanelpos);
			setTimeout(ninestars_add_free_spins, 1000 / fps);
			return;
		}

		freepanelpos = 0;

		in_free_spins = true;
		in_free_spins_pos = 0;
		madnes_set_text("free1", in_free_spins_pos.toString());
		in_free_spins_tmp = true;
	}

	if(in_free_spins_total * 1 != server_result.result.freeSpinNumber * 1)
	{
		madnes_audio_play("Btn_bet_mi");
		in_free_spins_total++;
		madnes_set_text("free2", in_free_spins_total.toString());

		setTimeout(function()
		{
			ninestars_add_free_spins();
		}, 120);
	}
	else
	{
		if(!in_free_spins || in_free_spins_tmp)
		{
			in_free_spins_tmp = false;
			for(var i = 0; i < 3; i++)
			{
				for(var j = 0; j < 3; j++)
				{
					madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
				}
			}

			//madnes_audio_pause('BACKGROUND');
			//madnes_audio_loop('BACKGROUND_FS');

			setTimeout("ninestars_control_freespins()", 1000);
		}
		else
		{
			setTimeout("ninestars_control_freespins()", 1000);
		}
	}
}
*/

var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu
/*
function ninestars_control_freespins()
{
	if(server_result.result.freeSpinResults[in_free_spins_pos] == null || typeof server_result.result.freeSpinResults[in_free_spins_pos] == "undefined")
	{
		if(freepanelpos < 200)
		{
			freepanelpos = freepanelpos * 1 + 10;
			madnes_set_pos_y("table_free-spins", he + freepanelpos);
			madnes_set_pos_y("free1", he + freepanelpos);
			madnes_set_pos_y("free2", he + freepanelpos);
			setTimeout(ninestars_control_freespins, 1000 / fps);
			return;
		}

		freepanelpos = 200;

		in_free_spins = false;
		in_free_spins_tmp = false;
		in_free_spins_pos = 0;
		madnes_set_text("free1", in_free_spins_pos.toString());
		in_free_spins_total = 0;
		madnes_set_text("free2", in_free_spins_total.toString());


		madnes_end_round();

		ninestars_money_add_control();
	}
	else
	{
		result_lock = 1;
		result_tmp = server_result.result.freeSpinResults[in_free_spins_pos].result.reelMatrix;

		server_result.result.freeSpinNumber = server_result.result.freeSpinResults[in_free_spins_pos].result.freeSpinNumber;

		setTimeout("ninestars_set_result_freespin()", 1000);

		server_result.result.lineWins = server_result.result.freeSpinResults[in_free_spins_pos].result.lineWins;
		server_result.result.gameSpecifics = server_result.result.freeSpinResults[in_free_spins_pos].result.gameSpecifics;

		rotated = 0;

		ninestars_rotate_start();
		in_free_spins_pos++;
		madnes_set_text("free1", in_free_spins_pos.toString());
	}
}
*/
// Navrat vysledku na konci freespinu
function ninestars_set_result_freespin()
{
    set_result_lock(0); // result_lock = 0;
    server_result.result.reelMatrix = result_tmp;
}

var toboom = [];
var boom_reel_pos = 0;
var tetris_fst = false;
var tetris_pos = 0;

var anim_diff_time = 0;

// Otoceni wild symbolu
function ninestars_result_control_part_proc_trn(win_set)
{
    for(var i = 0; i < reels_pos.length; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            if(
                madnes_anim_is_playing("reels_bufer_" + i + "_TMP" + j) ||
                madnes_anim_is_playing("reels_bufer_" + i + "_S" + j)
            )
            {
                //console.log("skip 1");
                setTimeout(
                    function() {
                        ninestars_result_control_part_proc_trn(win_set);
                    }, 1000 / fps
                );
                return;
            }
        }
    }
    ninestars_print_reels();


    if(win_set.type == "bonus")
    {
        madnes_audio_fade_out("2x_long", 500);

        madnes_anim_stop("bigwin_x2_background_sprite");
        madnes_set_pos("bigwin_x2_background_sprite", -9999, -9999);
        madnes_set_pos("reels_full_plate", -9999, -9999);


        ninestars_bonus_start(win_set);

    }
    else if(win_set.type == "star")
    {
        var pos0 = win_set.position[0][1] * 1 + win_set.position[0][0] * 3;
        //ninestars_stars_list[server_config.logic.bet_set.indexOf(bet * 100 * coin_val)][pos0] = 1;

        ninestars_stars_list[wallet.getBetSet().indexOf(madnes_get_atomic_bet(bet))][pos0] = 1;
        ninestars_infomenu_update();
        ninestars_result_control_part_proc_nxt(win_set);
    }
    else if(win_set.type == "normal")
    {
        if(typeof win_set.win != "undefined")
        {
            // win = win * 1 + win_set.win * win_set.multiplier;
            madnes_add_win(win_set.win * win_set.multiplier)
        }

        for(var i = 0; i < 3; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                var text = madnes_get_texture("reels_bufer_" + i + "_S" + j);
                text = text.replace("_blur", "");

                madnes_set_texture("reels_bufer_" + i + "_TMP" + j, text + "_light");
                if(madnes_get_pos_y("reels_bufer_" + i + "_S" + j) > 0)
                {
                    madnes_set_pos_y(
                        "reels_bufer_" + i + "_TMP" + j,
                        madnes_get_pos_y("reels_bufer_" + i + "_S" + j)
                    );

                    madnes_set_scale(
                        "reels_bufer_" + i + "_TMP" + j,
                        1,
                        madnes_get_scale_y( "reels_bufer_" + i + "_S" + j )
                    );

                    madnes_set_pos_y("reels_bufer_" + i + "_S" + j, -9999);
                }

            }
        }

        for(var pos in win_set.position)
        {
            var text = madnes_get_texture("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ));
            text = text.replace("_blur", "");

            if(madnes_get_texture("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] )) != text)
            {
                madnes_set_texture("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), text)
                for(var anim in icons[text])
                {
                    madnes_anim_add("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), anim, icons[text][anim]);
                }
            }

            if(madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )) > 0)
            {
                madnes_set_pos_y(
                    "reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ),
                    madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ))
                );

                madnes_set_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ), -9999);
            }

            madnes_set_scale(
                "reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ),
                1,
                madnes_get_scale_y( "reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ) )
            );

        }

        for(var pos in win_set.position)
        {
            setTimeout(madnes_anim_play.bind(this, "reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "anim", 40), 10);
        }

        setTimeout(function()
        {
            ninestars_result_control_part_proc_nxt(win_set);
        }, 800);

    }
    else
    {
        console.log("!!!!!!!" + win_set.type);
        ninestars_result_control_part_proc_nxt(win_set);
    }
}

var topos = [];
var tpos_f = [];

// Konec animace -> prejit na kontrolu dalsi (pouze nacasovani)
export function ninestars_result_control_part_proc_nxt(win_set)
{
    // Caru -> zvuk -> zabarvit -> otocit -> prostrelit -> otocit zpet -> (posunout)

    for(var i = 0; i < reels_pos.length; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            if(
                madnes_anim_is_playing("reels_bufer_" + i + "_TMP" + j) ||
                madnes_anim_is_playing("reels_bufer_" + i + "_S" + j)
            )
            {
                //console.log("skip 2");
                setTimeout(
                    function() {
                        ninestars_result_control_part_proc_nxt(win_set);
                    }, 1000 / fps
                );
                return;
            }
        }
    }

    for(var i = 1; i <= 5; i++)
    {
        madnes_alpha_to("winline_number_" + i + "_l_a", 0, 250);
        madnes_alpha_to("winline_number_" + i + "_r_a", 0, 250);
    }

    madnes_alpha_to("active_winline_left_mid", 0, 250);
    madnes_alpha_to("active_winline_right_mid", 0, 250);

    madnes_alpha_to("active_winline_left_mid_top", 0, 250);
    madnes_alpha_to("active_winline_right_mid_top", 0, 250);

    madnes_alpha_to("active_winline_left_mid_bot", 0, 250);
    madnes_alpha_to("active_winline_right_mid_bot", 0, 250);

    madnes_alpha_to("active_winline_left_bottom", 0, 250);
    madnes_alpha_to("active_winline_right_top", 0, 250);

    madnes_alpha_to("active_winline_left_top", 0, 250);
    madnes_alpha_to("active_winline_right_bottom", 0, 250);


    //ninestars_print_reels();

    setTimeout(function() {
        result_control_pos++;
        ninestars_result_control_part();
    }, 1000 / fps);
}







var win_anim_played = false;

// Zacatek kontroly pridavani penez
function ninestars_money_add_control()
{
    set_inwincount(false); // inwincount = false;

    if(!win_anim_played && win * 1 > 0)
    {
        ninestars_money_add_win(madnes_money_to_coin(win));
        //madnes_audio_loop('remittance_A');

    }
    else
    {
        setTimeout(madnes_audio_stop.bind(null, 'remittance_A'), 200);
        madnes_audio_continue('BACKGROUND');

        end_result_control();
    }
}

function end_result_control()
{
    madnes_end_round();
}

export function ninestars_end_round_recalced() {

    set_inwincount(false); // inwincount = false;
    set_inmoneyadd(false); // inmoneyadd = 0;
    set_inanim(false); // inanim = 0;
    win_anim_played = false;

    // madnes_on_end_round_recount(win);
    // madnes_on_round_end();
    // madnes_recount_bet(null, false);

    let atomBet = madnes_get_atomic_bet(bet);
    let indexBet = wallet.getBetSet().indexOf(atomBet);

    try {
        ninestars_stars_list[indexBet] = madnes_get_game_specifics().stars;
    } catch(e) {
        console.log(e);
    }

    ninestars_star_control();

    // autospin_force_enabled = false;
    // if(is_in_autostart() || autospin_force)
    // {
    //     autospin_force = false;
    //     madnes_rotate_start();
    //     return;
    // }
}

function is_in_autostart()
{
    return !!autostart;
    //return autostart * 1 > 0 || autostart == "∞";
}

var inbigwin = 0; // Jsme v bigwin modu?
var inmoneyadd = 0; // Prodavaji se aktualne penize
var fromsaloon = 0; // Prichazime ze saloonu? nebude vybuch
var boom_digits = 0; // pocet cislic pri vybuchu
var boom_ready = 0;  // je vybuch dokoncen / pripraven pro vypisovani cislic
var boom_sum = 0;   // aktualni suma na papire vybuchu

var moneyadd_pos = 0;
var moneyadd_dir = 0;
var money_add_win_speed = 18;

function ninestars_money_add_win(max)
{
    if(inmoneyadd == 0 && inbigwin == 0 && fromsaloon == 0)
    {
        if(max*1 > bet * 1 * big_win)
        {
            states.setState(STATES.BONUS_WIN);
            ninestars_money_add_big_win(max);
            // madnes_hide_btns();
            return;
        }

        inmoneyadd = 1;
    }

    madnes_set_img_center("moneyadd_text_bg", 0.5, 0.46);

    win_anim_played = true;

    ninestars_show_money(max, function() {

        //ninestars_star_control();
        ninestars_money_add_control();

    });

    inbigwin = 0;
    set_inbigwin(false);
    fromsaloon = 0;
}

var moneyadd_time_super_1 = 1300;
var moneyadd_time_super_2 = 4000;
var moneyadd_time_mega_1 = 1400;
var moneyadd_type = "";

function ninestars_money_add_big_win(max)
{
    inbigwin = 1;
    set_inbigwin(true);

    if(bet * super_win <= max)
    {
        moneyadd_type = "super";
        madnes_audio_play("Win_super_in");
        ninestars_money_add_big_win_anim_add_total = ninestars_money_add_big_win_anim_add_super;
    }
    else if(bet * mega_win <= max)
    {
        moneyadd_type = "mega";
        madnes_audio_play("Win_mega_in");
        ninestars_money_add_big_win_anim_add_total = ninestars_money_add_big_win_anim_add_mega;
    }
    else
    {
        moneyadd_type = "big";
        madnes_audio_play("Win_big_in");
        ninestars_money_add_big_win_anim_add_total = ninestars_money_add_big_win_anim_add_big;
    }

    ninestars_money_add_big_win_anim_step = 0;
    setTimeout(madnes_start_coin, 800);
    setTimeout(ninestars_money_add_big_win_anim.bind(null, max), 1000);
}

var ninestars_money_add_big_win_anim_step = 0;
var ninestars_money_add_big_win_anim_max = 0;
function ninestars_money_add_big_win_anim(max)
{
    switch(ninestars_money_add_big_win_anim_step)
    {
        case 0:
            madnes_set_pos("bigwin_background_sprite", wi / 2, he * 0.4);
            //madnes_set_scale("bigwin_background_sprite", 1, 1);
            madnes_anim_loop("bigwin_background_sprite", "anim", 30);

            madnes_set_alpha("bigwin_background_sprite", 0);
            madnes_alpha_to("bigwin_background_sprite", 1, 600);

            madnes_set_pos("bigwin_background", wi / 2, he * 0.4);
            madnes_set_alpha("bigwin_background", 0);
            madnes_alpha_to("bigwin_background", 1, 600);

            madnes_set_alpha("bigwin_text", 1);
            madnes_set_alpha("bigwin_text2", 1);
            madnes_set_alpha("bigwin_text3", 1);
            madnes_set_pos("bigwin_text", -wi / 2, he * 0.4);
            madnes_move_to("bigwin_text", wi / 2, he * 0.4, 400);

            madnes_set_text("bigwin_text_sum", "0");
            madnes_set_pos("bigwin_text_sum", wi / 2, he * 0.521);
            madnes_set_alpha("bigwin_text_sum", 0);
            madnes_alpha_to("bigwin_text_sum", 1, 600);

            ninestars_money_add_big_win_anim_max = max;

            ninestars_money_add_big_win_anim_step = 1;
            ninestars_money_add_big_win_anim_add_start = madnes_microtime(true);
            madnes_add_to_render(ninestars_money_add_big_win_anim_add);

            break;
        case 4:
            madnes_alpha_to("bigwin_background_sprite", 0, 800);
            madnes_alpha_to("bigwin_background", 0, 800);
            madnes_alpha_to("bigwin_text", 0, 800);
            madnes_alpha_to("bigwin_text2", 0, 800);
            madnes_alpha_to("bigwin_text3", 0, 800);
            madnes_alpha_to("bigwin_text_sum", 0, 800, ninestars_money_add_big_win_anim);
            ninestars_money_add_big_win_anim_step = 5;
            break;
        case 5:
            madnes_set_pos("bigwin_background_sprite", -9999, -9999);
            madnes_set_pos("bigwin_background", -9999, -9999);
            madnes_set_pos("bigwin_text", -9999, -9999);
            madnes_set_pos("bigwin_text2", -9999, -9999);
            madnes_set_pos("bigwin_text3", -9999, -9999);
            madnes_set_pos("bigwin_text_sum", -9999, -9999);
            ninestars_money_add_big_win_anim_step = 0;

            inmoneyadd = 0;
            inbigwin = 0;
            set_inbigwin(false);
            fromsaloon = 0;
            win_anim_played = true;

            if(madnes_audio_is_playing("Win_super_in"))
            {
                madnes_audio_fade_out("Win_super_in", 1000);
            }
            if(madnes_audio_is_playing("Win_mega_in"))
            {
                madnes_audio_fade_out("Win_mega_in", 1000);
            }
            if(madnes_audio_is_playing("Win_big_in"))
            {
                madnes_audio_fade_out("Win_big_in", 1000);
            }

            // madnes_show_btns();

            //ninestars_star_control();
            ninestars_money_add_control();

            break;
    }

}

var ninestars_money_add_big_win_anim_add_big = 1.6;
var ninestars_money_add_big_win_anim_add_mega = 4;
var ninestars_money_add_big_win_anim_add_super = 6.6;
var ninestars_money_add_big_win_anim_add_start = 0;
var ninestars_money_add_big_win_anim_add_total = 0;

var ninestars_money_add_big_win_anim_add_pos = 0;
function ninestars_money_add_big_win_anim_add()
{
    var pos = 0;

    /*
    var pos = madnes_get_text("bigwin_text_sum").replace(/ /g, "");
    var add = ninestars_money_add_big_win_anim_max * ( Math.random() * ( ninestars_money_add_big_win_anim_max / 100000 ) );
    console.log(add);
    if(add < 1)
    {
        add = 1;
    }
    pos = Math.round( pos * 1 + add * 1 );
    */

    var diff = madnes_microtime(true) - ninestars_money_add_big_win_anim_add_start;

    if(moneyadd_type == "super")
    {
        //debugger;
        if(diff * 1000 < moneyadd_time_super_1)
        {
            pos = bet * mega_win * ( ( 100 / moneyadd_time_super_1 ) * diff ) * 10;
        }
        else if(diff * 1000 < moneyadd_time_super_2)
        {
            pos = ( bet * mega_win );
            var t2 = ( bet * super_win ) - pos;
            t2 = t2 * ( 100 / (moneyadd_time_super_2 - moneyadd_time_super_1) ) * ( diff - moneyadd_time_super_1 / 1000 ) * 10;
            pos = pos + t2;
        }
        else
        {
            pos = ( bet * super_win );
            var t2 = ninestars_money_add_big_win_anim_max - pos;
            t2 = t2 * ( 100 / (ninestars_money_add_big_win_anim_add_total * 1000 - moneyadd_time_super_2 ) ) * ( diff - moneyadd_time_super_2 / 1000 ) * 10;
            pos = pos + t2;
        }
        pos = Math.round(pos);
    }
    else if(moneyadd_type == "mega")
    {
        if(diff * 1000 < moneyadd_time_mega_1)
        {
            pos = bet * mega_win * ( ( 100 / moneyadd_time_mega_1 ) * diff ) * 10;
        }
        else
        {
            pos = ( bet * mega_win );
            var t2 = ninestars_money_add_big_win_anim_max - pos;
            t2 = t2 * ( 100 / (ninestars_money_add_big_win_anim_add_total * 1000 - moneyadd_time_mega_1 ) ) * ( diff - moneyadd_time_mega_1 / 1000 ) * 10;
            pos = pos + t2;
        }
        pos = Math.round(pos);
    }
    else
    {
        var perc = ( ( 100 / ninestars_money_add_big_win_anim_add_total ) * diff) / 100;
        pos = perc * ninestars_money_add_big_win_anim_max;
        pos = Math.round(pos);
    }

    if(mega_win * bet <= pos && ninestars_money_add_big_win_anim_step == 1)
    {
        madnes_move_to("bigwin_text", wi * 1.5, he * 0.4, 400);
        madnes_set_pos("bigwin_text2", -wi / 2, he * 0.4);
        madnes_move_to("bigwin_text2", wi / 2, he * 0.4, 400);

        ninestars_money_add_big_win_anim_step = 2;
    }

    if(super_win * bet <= pos && ninestars_money_add_big_win_anim_step == 2)
    {
        madnes_move_to("bigwin_text2", wi * 1.5, he * 0.4, 400);
        madnes_set_pos("bigwin_text3", -wi / 2, he * 0.4);
        madnes_move_to("bigwin_text3", wi / 2, he * 0.4, 400);

        ninestars_money_add_big_win_anim_step = 3;
    }

    if(pos >= ninestars_money_add_big_win_anim_max)
    {
        pos = ninestars_money_add_big_win_anim_max;
        madnes_rem_from_render(ninestars_money_add_big_win_anim_add);
        madnes_stop_coin();
        madnes_audio_play('remittance_B');
        setTimeout(function() {
            ninestars_money_add_big_win_anim_step = 4;
            ninestars_money_add_big_win_anim(ninestars_money_add_big_win_anim_max);
        }, 2000);
    }
    else
    {
        if(ninestars_money_add_big_win_anim_add_pos++ % 4 == 0)
        {
            madnes_audio_play('remittance_A');
        }
    }

    madnes_set_text("bigwin_text_sum", pos);
}

// Konec kontroly penez


function ninestars_star_control()
{
    if(typeof server_result == "object")
    {
        //var pos = server_config.logic.bet_set.indexOf(bet);
        //var set = server_result.result.gameSpecifics.specialState.permanentSymbols[pos];

        try {
            set_ninestars_stars_list(madnes_get_game_specifics().specialState.permanentSymbols);
            // ninestars_stars_list = server_result.result.gameSpecifics.specialState.permanentSymbols;
        } catch (e) {
            console.log(e);
            return;
        }


        ninestars_infomenu_update();
    }
}

